import { useUser } from '@/api';
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
  Button,
  Popover,
  PopoverContent,
  PopoverLink,
  PopoverTrigger,
} from '@/components/atoms';
import { ChevronDown } from 'lucide-react';
import { profilePopoverLinks } from '@/lib/constants';

function ProfilePopover() {
  const { data: user } = useUser('me');

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" className="rounded-full p-1! md:pr-2 gap-1">
          <Avatar>
            <AvatarImage
              alt={`${user?.firstName} ${user?.lastName}`}
              src={user?.avatar?.url}
              className=""
            />
            <AvatarFallback>
              {user?.firstName?.[0]}
              {user?.lastName?.[0]}
            </AvatarFallback>
          </Avatar>
          <span className="max-md:hidden">
            {user?.firstName} {user?.lastName}
          </span>
          <ChevronDown
            className="size-4 max-md:hidden shrink-0 text-muted-foreground"
            aria-hidden
          />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        align="end"
        side="bottom"
        className="flex flex-col p-1 gap-1 text-xs w-fit"
      >
        <>
          {profilePopoverLinks.map((link, index) => (
            <PopoverLink key={index} {...link} />
          ))}
        </>
      </PopoverContent>
    </Popover>
  );
}

export { ProfilePopover };
